import { Box, Tab, Tabs, Typography, useMediaQuery } from '@mui/material'
import { CompetitionFilters } from 'pages/purchase-pages/competitions/CompetitionFilters'
import { CompetitionTable } from 'pages/purchase-pages/competitions/CompetitionTable'
import { CustomPagination } from 'components/purchase/CustomPagination'
import { CustomTabPanel } from 'components/purchase/CustomTabs'
import { PurchaseLayout } from 'hoc/PurchaseLayout'
import React, { useState } from 'react'
import { useQueryState } from 'react-router-use-location-state'
import { ProcurementMethods, useTendersOverviewSearchQuery } from 'services/tender'
import { EmptyTableState } from 'components/purchase/EmptyTableState'
import { TenderSearchFilters } from 'pages/tender-search/tender-search-filter'
import { useTranslation } from 'react-i18next'

function a11yProps(index: number, isMobile: boolean) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    sx: {
      fontSize: isMobile ? '14px' : '16px',
      fontWeight: 400,
      alignItems: 'flex-start',
      padding: isMobile ? '0 5px 10px' : '0 20px 10px',
      borderBottom: 0.5,
      borderColor: 'divider',
    },
  }
}

export const initialFilters: TenderSearchFilters = {
  name: '',
  orgName: '',
  startFrom: null,
  startUntil: null,
  status: ['ONGOING'],
}

export const Competitions: React.FC = () => {
  const [value, setValue] = React.useState(0)
  const isMobile = useMediaQuery('(max-width: 550px)')
  const { t } = useTranslation()

  const [filters, setFilters] = useState<TenderSearchFilters>(initialFilters)

  const rowsPerPage = 10
  const [page, setPage] = useQueryState('page', 0)

  const args = {
    page,
    size: rowsPerPage,
    name: filters.name,
    orgName: filters.orgName,
    startFrom: filters.startFrom,
    startUntil: filters.startUntil,
    status: filters.status,
    method:
      value === 0
        ? ProcurementMethods.OPEN_TENDER
        : value === 1
          ? ProcurementMethods.PRICE_INQUIRY
          : ProcurementMethods.TWO_STAGE_TENDER,
  } as const

  const { data: tenders } = useTendersOverviewSearchQuery(args, {
    refetchOnMountOrArgChange: true,
  })

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }
  return (
    <PurchaseLayout>
      <Typography variant="h5">{t('competition_declarations')}</Typography>
      <Box
        sx={{
          width: isMobile ? '300px' : '100%',
        }}
      >
        <Tabs value={value} onChange={handleChange} variant="scrollable">
          <Tab label={t(`OPEN_TENDER`)} {...a11yProps(0, isMobile)} />
          <Tab label={t(`PRICE_INQUIRY`)} {...a11yProps(1, isMobile)} />
          <Tab label={t(`TWO_STAGE_TENDER`)} {...a11yProps(2, isMobile)} />
        </Tabs>
      </Box>
      <CompetitionFilters defaultValues={filters} setFilters={setFilters} />
      {tenders?.items && tenders?.items.length > 0 ? (
        <>
          <CustomTabPanel value={value} index={0}>
            <CompetitionTable tenders={tenders?.items} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <CompetitionTable tenders={tenders?.items} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <CompetitionTable tenders={tenders?.items} />
          </CustomTabPanel>
        </>
      ) : (
        <EmptyTableState />
      )}
      {tenders?.info.totalRows !== 0 && (
        <CustomPagination
          total={tenders?.info.totalRows!}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={setPage}
        />
      )}
    </PurchaseLayout>
  )
}
